export const consentstats = (hasConsent: boolean = false): any => {

  if (window.ama) {
    window.ama.adStats.add([
      {
        placement: hasConsent ? 'optin' : 'optout',
        gptEvent: 'slotRequested',
      },
    ]);
    window.ama.adStats.push();
  }

};